var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":_vm.title,"visible":_vm.visible,"okText":_vm.okText,"cancelText":_vm.cancelText,"confirmLoading":_vm.confirmLoading},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_c('a-form',{attrs:{"form":_vm.form,"layout":"vertical"}},[_c('a-form-item',[_c('a-textarea',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'reason',
          {
            rules: [{ required: true, message: _vm.requiredMessage }]
          }
        ]),expression:"[\n          'reason',\n          {\n            rules: [{ required: true, message: requiredMessage }]\n          }\n        ]"}],attrs:{"placeholder":_vm.placeholder,"rows":4}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }